import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { Window } from "@progress/kendo-react-dialogs";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import DavetliKatilimciService from "../../../services/srv-davetli/DavetliKatilimciService";
import { FormInput, FormNumericTextBox } from "../../../components/sys-form/FormComponents";
import {
  emailValidator,
  requiredValidator,
} from "../../../components/sys-form/FormValidators";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
} from "../../../utils/common";
import { confirmAlert } from "react-confirm-alert";

export const GuestParticipantAdd = (props) => {
  const { t } = useTranslation();

  const onSubmit = (dataItem) => {
    const { isValid, values } = dataItem;
    if (!isValid) return;

    if (!values.email && !values.telefon) {
      defaultAlertMessages.MessageDetailError = t("phone_or_email_required");
      confirmAlert({
        customUI: ({ onClose }) => {
          return getConfirmErrorMessage(onClose, defaultAlertMessages);
        },
      });
      return;
    }

    DavetliKatilimciService.add({
      DAVETLI_ETKINLIK_TANIM_ID: props.event.davetlI_ETKINLIK_TANIM_ID,
      AD: values.ad,
      SOYAD: values.soyad,
      TELEFON: values.telefon || null,
      EMAIL: values.email || null,
      TOPLAM_DAVETLI_SAYISI: values.toplamDavetliSayisi ?? 1,
    }).then((res) => {
      if (!res) return;
      props.toggleDialog();
      props.setIsAdded(true);
    });
  };

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"65vh"}
      initialWidth={"35%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Form
          onSubmitClick={onSubmit}
          initialValues={{ toplamDavetliSayisi: 1 }}
          render={(formRenderProps) => (
            <div style={{ alignSelf: "center", width: "80%" }}>
              <FormElement>
                <Field
                  name="ad"
                  id="ad"
                  label={t("name")}
                  component={FormInput}
                  validator={(value) => requiredValidator(value, t)}
                />
                <Field
                  name="soyad"
                  id="soyad"
                  label={t("surname")}
                  component={FormInput}
                  validator={(value) => requiredValidator(value, t)}
                />
                <Field
                  name="telefon"
                  id="telefon"
                  label={t("phone")}
                  component={FormInput}
                />
                <Field
                  name="email"
                  id="email"
                  label={t("email")}
                  component={FormInput}
                  validator={(value) =>
                    value ? emailValidator(value, t) : ""
                  }
                />
                <Field
                  name="toplamDavetliSayisi"
                  id="toplamDavetliSayisi"
                  label={t("total_guest_count")}
                  component={FormNumericTextBox}
                  min={1}
                  max={50}
                />
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginTop: "8px",
                    marginBottom: "12px",
                    lineHeight: 1.35,
                  }}
                >
                  {t("total_guest_count_hint")}
                </div>
                <div className="k-form-buttons">
                  <Button disabled={!formRenderProps.allowSubmit}>
                    {t("save")}
                  </Button>
                </div>
              </FormElement>
            </div>
          )}
        />
      </div>
    </Window>
  );
};
